<template>
  <ValidationObserver ref="tasksPage" id="tasksPage" name="tasksPage">
    <div v-if="loadingTasks" class="text-center font-size-h2">
      <b-spinner variant="primary"></b-spinner>
    </div>

    <div v-if="!loadingTasks && (!Array.isArray(allTasks) || allTasks.length === 0)">
      <div class="form-group">
        <h4 class="text-center">No data available.</h4>
      </div>
    </div>

    <div v-if="!loadingTasks && Array.isArray(allTasks) && allTasks.length > 0">

<!--      <b-table hover :items="allTasks" :fields="headers"></b-table>-->

      <b-card body-class="p-2">
        <h5 class="font-weight-bold">Filters</h5>
        <div class="form-group row mb-0">
          <label class="col-1 col-form-label text-right">Owner</label>
          <div class="col-2">
            <b-form-select class="custom-select custom-select-md" v-model="filterOwner" @input="filterByOwner">
              <option :value="null">All</option>
              <option v-for="owner in allOwners" :value="owner" :key="owner">
                {{ owner }}
              </option>
            </b-form-select>
          </div>
          <label class="col-1 col-form-label text-right">Status</label>
          <div class="col-2">
            <b-form-select class="custom-select custom-select-md" v-model="filterStatus" @input="filterByStatus">
              <option :value="null">All</option>
              <option>Open</option>
              <option>Completed</option>
            </b-form-select>
          </div>
        </div>
      </b-card>

      <table class="table table-hover table-bordered mt-5">
        <thead>
          <th width="10%" class="text-center font-size-h6">Status</th>
          <th width="10%" class="text-center font-size-h6">Owner</th>
          <th width="40%" class="text-center font-size-h6">Subject</th>
          <th width="10%" class="text-center font-size-h6">Due Date</th>
          <th width="30%" class="text-center font-size-h6">Details</th>
        </thead>
        <tbody>
          <tr v-for="(task, index) in allTasks" :key="index">
            <td class="text-center align-middle">
              <b-badge :variant="getStatusVariant(task.Status)">{{task.Status}}</b-badge>
            </td>
            <td class="text-center align-middle">
              {{ task.Owner ? task.Owner.name : '' }}
            </td>
            <td class="align-middle">
              <div>{{ task.Subject }}</div>
            </td>
            <td class="text-center">
              {{ task.Due_Date | dateParse("YYYY-MM-DD") | dateFormat("DD/MM/YYYY")}}
              <span v-if="isOverdue(task)" title="Overdue" class="ml-2">
                <i class="fa fa-md fa-exclamation-circle text-danger"></i>
              </span>
            </td>
            <td>
              <b-card v-if="task.Description" body-class="p-2 bg-light" class="mb-5">
                <b-card-text>
                  <span v-html="task.Description"></span>
                </b-card-text>
              </b-card>
            </td>
          </tr>
        </tbody>
      </table>

    </div>
  </ValidationObserver>
</template>

<style lang="scss">
</style>

<script>
import moment from 'moment-timezone';
import _ from 'lodash';

export default {
  name: "TasksPage",

  components: {},

  props: {
    tasks: Array,
    loadingTasks: Boolean
  },

  data() {
    return {
      allTasks: null,

      filterOwner: null,
      filterStatus: null,

      headers: [
        { key: "Status", label: "Status", sortable: true, thStyle: {width: '10%'} },
        { key: "Owner", label: "Owner", sortable: true, thStyle: {width: '10%'}, sortByFormatted: true,
          formatter: function (value, key, task) {
            return task.Owner?.name;
          }
        },
        { key: "Subject", label: "Subject", sortable: false, thStyle: {width: '40%'} },
        { key: "Due Date", label: "Due_Date", sortable: true, thStyle: {width: '10%'}, sortByFormatted: true,
          formatter: function (value, key, task) {
            if(task.Due_Date) {
              return moment.tz(task.Due_Date, 'YYYY-MM-DD', 'Australia/Sydney').format('DD/MM/YYYY');
            }
          }
        },
        { key: "Description", label: "Description", sortable: false, thStyle: {width: '30%'} },
      ],
    };
  },

  watch: {
    tasks: function(newVal, oldVal) {
      this.allTasks = newVal;
    }
  },

  computed: {
    today: function() {
      return moment.tz('Australia/Sydney');
    },

    allOwners: function() {
      return [... new Set(_.map(this.tasks, 'Owner.name'))];
    }
  },

  methods: {
    filterByOwner: function () {
      if(this.filterOwner) {
        this.allTasks = _.filter(this.tasks, task => {
          return task.Owner?.name === this.filterOwner;
        });
      }
      else {
        this.allTasks = this.tasks;
      }
    },

    filterByStatus: function () {
      if(this.filterStatus) {
        if(this.filterStatus === 'Completed') {
          this.allTasks = _.filter(this.tasks, task => {
            return task.Status === 'Completed';
          });
        }
        else {
          this.allTasks = _.filter(this.tasks, task => {
            return task.Status !== 'Completed';
          });
        }
      }
      else {
        this.allTasks = this.tasks;
      }
    },

    getStatusVariant: function(status) {
      let variant = 'primary';
      switch (status) {
        case 'Completed': variant = 'secondary'; break;
      }
      return variant;
    },

    isOverdue: function(task) {
      if(task.Status !== 'Completed') {
        const dueDate = moment.tz(task.Due_Date, 'YYYY-MM-DD', 'Australia/Sydney');
        return dueDate.isBefore(this.today, 'date');
      }
      return false;
    }
  }
};
</script>
